<script setup>
import { useRouter, useRoute } from 'vue-router';
import ContactsTable from 'dashboard/components-next/Contacts/ContactsTable.vue';

defineProps({
  contacts: { type: Array, required: true },
  selectedContactIds: {
    type: Array,
    default: () => [],
  },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['toggleContact', 'toggleSelectAll', 'update:sort']);

const router = useRouter();
const route = useRoute();

const onClickViewDetails = async id => {
  const routeTypes = {
    contacts_dashboard_segments_index: ['contacts_edit_segment', 'segmentId'],
    contacts_dashboard_labels_index: ['contacts_edit_label', 'label'],
  };
  const [name, paramKey] = routeTypes[route.name] || ['contacts_edit'];
  const params = {
    contactId: id,
    ...(paramKey && { [paramKey]: route.params[paramKey] }),
  };

  await router.push({ name, params, query: route.query });
};

const handleToggleSelection = ({ id, value }) => {
  emit('toggleContact', { id, value });
};
</script>

<template>
  <ContactsTable
    :contacts="contacts"
    :selected-ids="selectedContactIds"
    :active-sort="activeSort"
    :active-ordering="activeOrdering"
    @show-contact="onClickViewDetails"
    @toggle-selection="handleToggleSelection"
    @toggle-select-all="emit('toggleSelectAll', $event)"
    @update:sort="emit('update:sort', $event)"
  />
</template>
